// Module-level loading counter — works outside React tree (axios interceptors)
type Listener = (isLoading: boolean) => void;

let pendingRequests = 0;
const listeners: Listener[] = [];

function notify()
{
  listeners.forEach(fn => fn(pendingRequests > 0));
}

export const loadingBar = {
  increment()
  {
    pendingRequests++;
    notify();
  },
  decrement()
  {
    pendingRequests = Math.max(0, pendingRequests - 1);
    notify();
  },
  subscribe(fn: Listener)
  {
    listeners.push(fn);
    return () =>
    {
      const idx = listeners.indexOf(fn);
      if (idx !== -1) listeners.splice(idx, 1);
    };
  },
};
